import { useTheme } from '../../contexts/ThemeContext';
import { Sun, Moon } from 'react-bootstrap-icons';
import './ThemeToggle.scss';

function ThemeToggle() {
    const { theme, toggleTheme } = useTheme();

    return (
        <button
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label={theme === 'dark' ? 'Világos mód' : 'Sötét mód'}
            title={theme === 'dark' ? 'Világos mód' : 'Sötét mód'}
        >
            {theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
        </button>
    );
}

export default ThemeToggle;
